import {
  type SearchTerminalAssignmentsRequest,
  type GetTerminalAssignmentRequest,
} from '@trukt/tms-api/TerminalAssignmentService';
import { createKey } from '../createKey';

const keyHandler = createKey('terminalAssignment');

export const TerminalAssignmentServiceKeys = {
  key: keyHandler.key,
  search: keyHandler.createMethod<SearchTerminalAssignmentsRequest>(),
  getById: keyHandler.createMethod<GetTerminalAssignmentRequest>(),
};
